//* Vue
import type { SetupContext } from "vue";
//* 组件库
import { node, animations } from "various-ui";
//* 组件属性
import type { ModuleProps, ModuleEmits } from "../index";

export const useComposable = (define: ModuleProps, emits: SetupContext<typeof ModuleEmits>["emit"]) => {
    //* 响应式变量
    const refs = {
        visible: ref<boolean>(false),
    };

    //* 节点
    const nodes = {
        candidates: ref<HTMLDivElement>(),
        container: ref<HTMLDivElement>(),
    };

    //* 响应事件
    const ons = {
        animation: animations.selector(true),
    };

    //* 工具库
    const utils = {
        get_option_class: (value: string) => {
            return {
                "ui-active": define.modelValue.includes(value),
                "ui-disabled-status": define.disabled.includes(value),
            };
        },
    };

    //* 函数列表
    const methods = {
        selected: (value: string) => {
            const index = define.modelValue.indexOf(value);
            if (define.disabled.includes(value)) return;
            else if (index == -1) emits("update:modelValue", [...define.modelValue, value]);
            else {
                emits(
                    "update:modelValue",
                    define.modelValue.filter((v) => v != value)
                );
            }

            emits("change");
        },

        //* 候选框隐藏事件
        hidden: (ev?: Event) => {
            if (ev?.target && nodes.container.value && nodes.candidates.value) {
                const n = ev.target as HTMLElement;
                if (node.includes(n, nodes.container.value) || node.includes(n, nodes.candidates.value)) {
                    return addEventListener("click", methods.hidden, { capture: true, once: true });
                }
            }

            //* 状态更新
            refs.visible.value = false;
        },

        show: () => {
            //* 判断候选项是否已被激活
            if (refs.visible.value) methods.hidden();
            else {
                //* 状态更新
                refs.visible.value = true;
                //* 隐藏事件
                nextTick(() => {
                    addEventListener("click", methods.hidden, { capture: true, once: true });
                });
            }
        },
    };

    //* 计算属性
    const computeds = {
        placeholder: computed(() => {
            if (define.modelValue.length) return "";
            else {
                return define.placeholder || "";
            }
        }),
    };

    return { ons, refs, nodes, utils, methods, computeds };
};
